import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const AddCustomChannelConnectionModal = React.lazy(
  () => import("./add-custom-channel-connection.modal"),
);

const AddCustomChannelConnection: iModalProps<
  typeof AddCustomChannelConnectionModal
> = {
  name: "add-custom-channel-connection",
  component: GenerateModalWithSuspense(AddCustomChannelConnectionModal),
};

export default AddCustomChannelConnection;
